import React, { useEffect, useState, createContext, useContext } from 'react';
import COPY from '../../messages/copy';

export type MessagesState = {
  messages: { [key: string]: string };
  formatMessage: (key: string, values: string[]) => string;
};

const defaultState: MessagesState = {
  messages: {},
  formatMessage: () => '',
};

type ContextType = {
  messages: { [key: string]: string };
  formatMessage: (key: string, values: string[]) => string;
};

export const MessageContext = createContext<ContextType>(defaultState);

const MessagesProvider: React.FC = ({ children }) => {
  const [state, setState] = useState(defaultState);

  useEffect(() => {
    const formatMessage = (key: string, values: string[]): string => {
      // @ts-ignore
      let message = COPY[key];
      if (!message) return '';

      values.forEach((value, index) => {
        message = message.replace(`{${index}}`, value);
      });

      return message;
    };

    const fetchMessages = async () => {
      setState({ messages: COPY, formatMessage });
    };

    fetchMessages();
  }, []);

  return <MessageContext.Provider value={state}>{children}</MessageContext.Provider>;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useMessageContext = () => useContext(MessageContext);

export default MessagesProvider;
